import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import {
  IconSize,
  SvgIconClass,
  TimelineItem,
} from '@digital-platform/rs-cms/domain';
import { BasePTypeComponent } from '../base-ptype/base-ptype.component';
import { RichTextComponent } from '../rich-text/rich-text.component';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'digital-platform-timeline-item',
  standalone: true,
  imports: [CommonModule, RichTextComponent, SvgIconComponent],
  templateUrl: './timeline-item.component.html',
  styleUrls: ['./timeline-item.component.scss'],
})
export class TimelineItemComponent
  extends BasePTypeComponent
  implements TimelineItem
{
  public override type = 'TimelineItem' as const;
  @Input() itemIcon: SvgIconClass | null = null;
  @Input() itemIconSize: IconSize | null = null;
  @Input() itemText: string | null = null;
  @Input() itemTitle: string | null = null;
  @Input() timelineFillColor: string | null = null;
  @Input() timelineStrokeColor: string | null = null;
  @Input() automationId?: string | null;
}
